import React from "react";

const Password = ({
	register,
	error,
	placeholder = "Enter your password",
	required = false,
	className = "",
	id,
	watch,
	errors = {},
	field = {},
}) => {
	const confirmId = `${id}_confirm`;
	const showConfirm = !!field.confirm;
	const confirmPlaceholder =
		field.confirm_placeholder || "Confirm your password";

	return (
		<div className={`password-field-group ${className}`}>
			<input
				type="password"
				id={id}
				className={`donate-field__input ${error ? "error" : ""}`}
				placeholder={placeholder}
				{...register(id, {
					required: required ? "Password is required" : false,
					minLength: {
						value: 8,
						message: "Password must be at least 8 characters long",
					},
				})}
			/>
			{error && <div className="field__error">{error.message}</div>}

			{showConfirm && (
				<>
					<input
						type="password"
						id={confirmId}
						className={`donate-field__input ${
							errors && errors[confirmId] ? "error" : ""
						}`}
						placeholder={confirmPlaceholder}
						{...register(confirmId, {
							required: required ? "Please confirm your password" : false,
							validate: (value) =>
								value === (watch ? watch(id) : "") || "Passwords do not match",
						})}
					/>
					{errors && errors[confirmId] && (
						<div className="field__error">{errors[confirmId].message}</div>
					)}
				</>
			)}
		</div>
	);
};

export default Password;
